const SecondPreviousResidence = {
  name: 'secondPreviousResidence',
  title: '2ND PREVIOUS RESIDENCE',
  container: 'collapse',
  GridProps: { xs: 12 },
  fields: [
    {
      variant: 'text',
      name: 'secondPreviousResidenceStreetAddress',
      label: 'Street Address',
      GridProps: { xs: 12, sm: 4 },
    },
    {
      variant: 'text',
      name: 'secondPreviousResidenceCity',
      label: 'City',
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'singleSelect',
      name: 'secondPreviousResidenceState',
      label: 'State/Province',
      placeholder: 'Select',
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'text',
      name: 'secondPreviousResidenceZipCode',
      label: 'Zip Code/Postal Code',
      GridProps: { xs: 12, sm: 2 },
    },
    {
      variant: 'date',
      name: 'secondPreviousResidenceMoveInDate',
      label: 'Move-In Date',
      placeholder: 'MM/DD/YYYY',
      rules: {
        validate: (value) => {
          if (value && value > new Date()) {
            return 'Move-in date cannot be a future date';
          }
          return true;
        },
      },
      GridProps: { xs: 12, sm: 2 },
    },
    {
      variant: 'currency',
      name: 'secondPreviousResidenceMonthlyPayments',
      label: 'Current Monthly Payments',
      rules: {
        min: 0,
      },
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'flexSpacer',
    },
    {
      name: 'secondPreviousOwnOrRentDetails',
      title: 'OWN OR RENT DETAILS',
      titleVariant: 'collapse',
      container: 'default',
      fields: [
        {
          variant: 'radioGroup',
          name: 'secondPreviousResidenceOwnOrRent',
          label: 'Do you currently Own or Rent your property?',
          options: [
            { label: 'Own', value: 'own' },
            { label: 'Rent', value: 'rent' },
            { label: 'Do not currently Own/Rent', value: 'other' },
          ],
          sx: {
            flexDirection: 'row',
          },
          GridProps: { xs: 12, marginTop: 2 },
        },
        {
          variant: 'text',
          name: 'secondPreviousResidenceLenderName',
          label: 'Lender Name',
          rules: {
            required: true,
          },
          watchFields: ['secondPreviousResidenceOwnOrRent'],
          hidden: ({ getValues }) =>
            getValues('secondPreviousResidenceOwnOrRent') !== 'own',
          GridProps: { xs: 12, sm: 6 },
        },
        {
          variant: 'phone',
          name: 'secondPreviousResidenceLenderPhone',
          label: 'Phone Number',
          placeholder: '(000) 000-0000',
          rules: {
            required: true,
          },
          watchFields: ['secondPreviousResidenceOwnOrRent'],
          hidden: ({ getValues }) =>
            getValues('secondPreviousResidenceOwnOrRent') !== 'own',
          GridProps: { xs: 12, sm: 6 },
        },
        {
          variant: 'text',
          name: 'secondPreviousResidenceLandlordName',
          label: 'Landlord/Condo/Apartment Name',
          rules: {
            required: true,
          },
          watchFields: ['secondPreviousResidenceOwnOrRent'],
          hidden: ({ getValues }) =>
            getValues('secondPreviousResidenceOwnOrRent') !== 'rent',
          GridProps: { xs: 12, sm: 6 },
        },
        {
          variant: 'phone',
          name: 'secondPreviousResidenceLandlordPhone',
          label: 'Phone Number',
          placeholder: '(000) 000-0000',
          rules: {
            required: true,
          },
          watchFields: ['secondPreviousResidenceOwnOrRent'],
          hidden: ({ getValues }) =>
            getValues('secondPreviousResidenceOwnOrRent') !== 'rent',
          GridProps: { xs: 12, sm: 6 },
        },
        {
          variant: 'text',
          name: 'secondPreviousResidenceReason',
          label: 'Reason',
          placeholder: 'Please explain...',
          multiline: true,
          rows: 3,
          rules: {
            required: true,
          },
          watchFields: ['secondPreviousResidenceOwnOrRent'],
          hidden: ({ getValues }) =>
            getValues('secondPreviousResidenceOwnOrRent') !== 'other',
          GridProps: { xs: 12 },
        },
        {
          variant: 'text',
          name: 'secondPreviousResidenceReasonForMoving',
          label: 'Reason for moving',
          placeholder: 'Please explain...',
          multiline: true,
          rows: 3,
          GridProps: { xs: 12 },
        },
      ],
    },
  ],
};

export default SecondPreviousResidence;
